/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserConfiguration } from '../fn/user-configurations/get-user-configuration';
import { GetUserConfiguration$Params } from '../fn/user-configurations/get-user-configuration';
import { updateUserConfiguration } from '../fn/user-configurations/update-user-configuration';
import { UpdateUserConfiguration$Params } from '../fn/user-configurations/update-user-configuration';
import { UserConfigurationDto } from '../models/user-configuration-dto';

@Injectable({ providedIn: 'root' })
export class UserConfigurationsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserConfiguration()` */
  static readonly GetUserConfigurationPath = '/v0/userConfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserConfiguration$Response(params?: GetUserConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UserConfigurationDto>> {
    return getUserConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserConfiguration(params?: GetUserConfiguration$Params, context?: HttpContext): Observable<UserConfigurationDto> {
    return this.getUserConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserConfigurationDto>): UserConfigurationDto => r.body)
    );
  }

  /** Path part for operation `updateUserConfiguration()` */
  static readonly UpdateUserConfigurationPath = '/v0/userConfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserConfiguration$Response(params: UpdateUserConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UserConfigurationDto>> {
    return updateUserConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserConfiguration(params: UpdateUserConfiguration$Params, context?: HttpContext): Observable<UserConfigurationDto> {
    return this.updateUserConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserConfigurationDto>): UserConfigurationDto => r.body)
    );
  }

}
